import NationalPerformanceCard from "../widgets/NationalPerformance/NationalPerformanceCard";
import RegionalTerritoryPerformanceCard from "../widgets/RegionalPerformance/RegionalTerritoryPerformanceCard";
import InsightCategoryCard from "../widgets/Insights/InsightCategoryCard";

export function NationalPerformanceTile({
  rows = [],
  isLoading = false,
  onExplore,
}) {
  return (
    <NationalPerformanceCard rows={rows} isLoading={isLoading} onExplore={onExplore} />
  );
}

export function RegionalTerritoryPerformanceTile({
  rows = [],
  subtitle,
  isLoading = false,
  onExplore,
}) {
  return (
    <RegionalTerritoryPerformanceCard
      rows={rows}
      subtitle={subtitle}
      isLoading={isLoading}
      onExplore={onExplore}
    />
  );
}

export function InsightPatientTrendsTile({
  title,
  badgeColor,
  rows = [],
  isLoading = false,
  onExplore,
  emptyMessage,
}) {
  return (
    <InsightCategoryCard
      title={title}
      badgeColor={badgeColor}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
      emptyMessage={emptyMessage}
    />
  );
}

export function InsightPhysicianBehaviorTile({
  title,
  badgeColor,
  rows = [],
  isLoading = false,
  onExplore,
  emptyMessage,
}) {
  return (
    <InsightCategoryCard
      title={title}
      badgeColor={badgeColor}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
      emptyMessage={emptyMessage}
    />
  );
}

export function InsightUtEngagementTile({
  title,
  badgeColor,
  rows = [],
  isLoading = false,
  onExplore,
  emptyMessage,
}) {
  return (
    <InsightCategoryCard
      title={title}
      badgeColor={badgeColor}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
      emptyMessage={emptyMessage}
    />
  );
}

export function InsightCompetitorDynamicsTile({
  title,
  badgeColor,
  rows = [],
  isLoading = false,
  onExplore,
  emptyMessage,
}) {
  return (
    <InsightCategoryCard
      title={title}
      badgeColor={badgeColor}
      rows={rows}
      isLoading={isLoading}
      onExplore={onExplore}
      emptyMessage={emptyMessage}
    />
  );
}
